import { createWebHistory, createRouter } from "vue-router";

import SummaryPage from "@/views/SummaryPage.vue";
import Calculator from "@/views/Calculator.vue";
import HomePage from "@/views/HomePage.vue";
import ServiceConfigurations from "@/views/ServiceConfigurations.vue";
import Compute from "@/components/services/Compute.vue";
import Databases from "@/components/services/Databases.vue";
import Storage from "@/components/services/Storage.vue";
import Network from "@/components/services/Network.vue";
import Software from "@/components/services/Software.vue";
import ManagedServices from "@/components/services/ManagedServices.vue";

const routes = [
  { path: "/", name: "Home", component: HomePage },
  { path: "/calculator", name: "WX1 Calculator", component: Calculator },
  {
    path: "/config/services",
    name: "ServiceConfigurations",
    component: ServiceConfigurations,
    children: [
      { path: "compute", component: Compute },
      // The section used to be called EC2; keep old links working.
      { path: "ec2", redirect: "/config/services/compute" },
      { path: "databases", component: Databases },
      { path: "storage", component: Storage },
      { path: "network", component: Network },
      { path: "software", component: Software },
      { path: "managed-services", component: ManagedServices },
    ],
  },
  { path: "/summary", name: "Summary", component: SummaryPage },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
